var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTermsOfUse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_387_15115",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_387_15115",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAB6ElEQVRoge2ZTS8DQRjH/89MVTdeEokDKeHgK1DUSdx64+jkJU7OPgvRiIPP4OxACF9BKCUSF9Iqaav7ODQOtmF2Z6Y2Ted36mGemflln//ONgM4HN0NRS1YfuIcM/YYSJss/Hh8d3a1OblgMgcAiKgFPmPXdPMAUCmUs9P5wqnpPJEFAIyZLgoAxE2JmYPCuck8OgLWIAbebsqzJhIJ1YCRfCFHLPa4Wkn77yXddVogEBj8Q+JyfXIu6jzKJ0AsdmGh51vnbUp8/9Z9EmFayErPByGQFYnYMkCwIxGbQKIv+adE5vAu1Cs2NoHhxZE/JcrXpWwYCeVbqF14E/0YX5tSDcuqBsR6DtjACcSNtQx81mpgn7VqZU8CQkqtWisClZdXnOSPAL39Yyg9ivnVFa1aKwJSSvR6Hnzf16pPeintta0IpAYHsLS9YWOqyLgMAC4DLgNWcBlwGTCg6zJg0vNBYsmASc8HiSUDJj0fpOMz0PF/aJxA3HSTAAFEqL7X2rebVoqqAeEFhADJHtxc3P6XRJGALdUg5R3Z6P5983jyG+DaB7heBTfqAGt+uSl43slEurcLfw4ICUp6gEyA/EbkjbWLMAIP+L4jEBIk7HzD/IKy54MoM8BMW2hKtJsiiJQ973A4fvIF21jHzzOmR0kAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsOfUse);
export default __webpack_public_path__ + "static/media/terms_of_use.63ef1d64980f945bb24a06b61865cad5.svg";
export { ForwardRef as ReactComponent };